export default "__VITE_ASSET__DIhjP1fM__"